// frontend/src/components/ui/AgencyLogo.jsx
import React, { useState, useEffect } from 'react';
import { useBranding } from '../../contexts/BrandingContext';

const AgencyLogo = ({ src, name = 'A', size = 64, className = '', rounded = 'lg' }) => {
  const { branding } = useBranding();
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    setLoadError(false);
  }, [src]);

  const isDataUrl = typeof src === 'string' && src.startsWith('data:');
  const radiusClass = rounded === 'full' ? 'rounded-full' : `rounded-${rounded}`;

  if (src && src.trim() !== '' && !loadError) {
    return (
      <img
        src={src}
        alt={name}
        crossOrigin={isDataUrl ? undefined : 'anonymous'}
        className={`${radiusClass} object-contain bg-card border border-border ${className}`}
        style={{ width: size, height: size }}
        onError={() => setLoadError(true)}
      />
    );
  }

  return (
    <div
      className={`${radiusClass} flex items-center justify-center text-white font-bold ${className}`}
      style={{ width: size, height: size, backgroundColor: branding.primaryColor }}
    >
      {(name?.charAt(0) || 'A').toUpperCase()}
    </div>
  );
};

export default AgencyLogo;


